export const AppName: Record<string, string> = {
  DEADLYDIGITS: 'Deadly Digits',
  RECKON: 'Reckon',
  ALL: 'Reckon',
};
